import { useContextValue } from '../context/LoaderContext';

const PLAN_KEYS = {
  ALL_IN_ONE: 'all_in_one',
  BASIC: 'basic',
};

export const usePlanPermissions = () => {
  const { activePlan } = useContextValue();
  const permissions = activePlan?.permissions;
  const loaded = Boolean(activePlan);

  return {
    loaded,
    permissions,
    billingPlanKey: activePlan?.billingPlanKey || activePlan?.billing?.planKey || null,
    canAccessBasic: Boolean(permissions?.has_basic),
    canAccessTrips: Boolean(permissions?.has_trips),
    canAccessZones: Boolean(permissions?.has_zones),
    canAccessReports: Boolean(permissions?.has_custom_report),
    isBundleBilling: Boolean(
      permissions?.has_all_in_one
      || activePlan?.billingPlanKey === PLAN_KEYS.ALL_IN_ONE,
    ),
    isBasicBilling: activePlan?.billingPlanKey === PLAN_KEYS.BASIC,
    trialActive: Boolean(activePlan?.trial?.isActive),
  };
};

export default usePlanPermissions;
